import { useEffect, useRef, useCallback } from 'react'
import { Strophe } from 'react-strophe'
import chatLog from '../global/chat-log'
import { Chat } from '../global/chatSettingsConfig'
import { payloadToPing } from '../global/xmppPayloadHelper'
import useInterval from './useInterval'

export default function useChatServerPing({ connection, dispatch }) {
  const pingRef = useRef()

  const sendPing = useCallback(() => {
    const pingFn = new Promise((resolve, reject) => {
      const stanza = payloadToPing()
      connection.sendIQ(stanza, resolve, reject, Chat.Settings.TIMEOUT)
    })

    pingFn
      .then(() => {
        chatLog(`[Ping] Chat server is up.`)
      })
      .catch((result) => {
        if (!result) {
          chatLog(`[Ping] Received no response from the server. Attempting to reconnect.`)
          clearInterval(pingRef.current)
          pingRef.current = false
          dispatch({ type: 'FAILED_TO_CONNECT', data: Strophe.Status.CONNFAIL })
        }
      })

    // keep the listener alive
    return true
  }, [connection, dispatch])

  useEffect(() => {
    if (!pingRef.current && connection) {
      pingRef.current = setInterval(sendPing, Chat.Settings.PING_INTERVAL)
    }
  }, [connection, sendPing])

  // This useInterval is to check connectivity at a
  // more frequent rate than aggressively pinging the server.
  useInterval(() => {
    if (!navigator.onLine) {
      chatLog(`[Connection] Appears to be offline.`)
      dispatch({ type: 'FAILED_TO_CONNECT', data: Strophe.Status.CONNFAIL })
    }
  }, 20000) // 20 seconds
}
